import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 1L1 13M1 1L13 13", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgClose;
